import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import AuthLayout from '@/components/layouts/AuthLayout/AuthLayout';
import BasicLayout from '@/components/layouts/BasicLayout/BasicLayout';
import ProtectedRoute from '@/components/protected-route/ProtectedRoute';
import { AuthFormContext } from '@/context/AuthFormContext';
import AuthConfirmCodePage from '@/pages/AuthPage/AuthConfirmCodePage/AuthConfirmCodePage';
import AuthNewPasswordPage from '@/pages/AuthPage/AuthNewPasswordPage/AuthNewPasswordPage';
import AuthPage from '@/pages/AuthPage/AuthPage';
import AuthRecoveryPasswordPage from '@/pages/AuthPage/AuthRecoveryPasswordPage/AuthRecoveryPassword';
import SsoPage from '@/pages/AuthPage/SsoPage/SsoPage';
import EducationPage from '@/pages/EducationPage/EducationPage';
import EmploymentCalendarPage from '@/pages/EmploymentCalendarPage/EmploymentCalendarPage';
import { AnalyticsPage, ManagementPage } from '@/pages/HR';
import LoggingPage from '@/pages/LoggingPage/LoggingPage';
import PageNotFound from '@/pages/PageNotFound/PageNotFound';
import PlanningPage from '@/pages/PlanningPage/PlanningPage';
import ProfilePage from '@/pages/ProfilePage/ProfilePage';
import ProjectCasePage from '@/pages/ProjectsCasePage/ProjectCasePage';
import ProjectsPage from '@/pages/ProjectsPage/ProjectsPage';
import ReportsPage from '@/pages/ReportsPage/ReportsPage';
import { RoutsPath } from '@/types';

const Router = () => {
	const [user, setUser] = useState<string>('');
	const [token, setToken] = useState<string>('');

	return (
		<Routes>
			<Route
				path='/auth'
				element={
					<AuthLayout>
						<AuthPage />
					</AuthLayout>
				}
			></Route>
			<Route
				path='/auth/sso'
				element={
					<AuthLayout>
						<SsoPage />
					</AuthLayout>
				}
			></Route>
			<Route
				path='/auth/recovery-password'
				element={
					<AuthFormContext.Provider value={{ user, setUser, token, setToken }}>
						<AuthLayout>
							<AuthRecoveryPasswordPage />
						</AuthLayout>
					</AuthFormContext.Provider>
				}
			></Route>
			<Route
				path='/auth/confirm-code'
				element={
					<AuthFormContext.Provider value={{ user, setUser, token, setToken }}>
						<AuthLayout>
							<AuthConfirmCodePage />
						</AuthLayout>
					</AuthFormContext.Provider>
				}
			></Route>
			<Route
				path='/auth/new-password'
				element={
					<AuthFormContext.Provider value={{ user, setUser, token, setToken }}>
						<AuthLayout>
							<AuthNewPasswordPage />
						</AuthLayout>
					</AuthFormContext.Provider>
				}
			></Route>
			<Route
				path='/logging'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<LoggingPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path='/'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<ProfilePage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path='/planning'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<PlanningPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path='/education'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<EducationPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path='/employment'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<EmploymentCalendarPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path='/projects'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<ProjectsPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path='/projects/:id'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<ProjectCasePage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path='/reports'
				element={
					<ProtectedRoute>
						<BasicLayout>
							<ReportsPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path={RoutsPath.hr_management}
				element={
					<ProtectedRoute>
						<BasicLayout>
							<ManagementPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route
				path={RoutsPath.hr_analytics}
				element={
					<ProtectedRoute>
						<BasicLayout>
							<AnalyticsPage />
						</BasicLayout>
					</ProtectedRoute>
				}
			></Route>
			<Route path='/404' element={<PageNotFound />}></Route>
			<Route path='*' element={<PageNotFound />}></Route>
		</Routes>
	);
};
export default Router;
